/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Plan_HintInputs */

const cs_auth_signup_plan_hint = /** @type {(inputs: Auth_Signup_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Během zkušební doby se faktura za tarif nevystaví.`)
};

const en_auth_signup_plan_hint = /** @type {(inputs: Auth_Signup_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No seat invoice is issued during the trial.`)
};

/**
* | output |
* | --- |
* | "No seat invoice is issued during the trial." |
*
* @param {Auth_Signup_Plan_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_plan_hint = /** @type {((inputs?: Auth_Signup_Plan_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Plan_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_plan_hint(inputs)
	return cs_auth_signup_plan_hint(inputs)
});